import React from 'react'
import { useState } from 'react'
import '../App.css'
import { useNavigate, Link } from 'react-router-dom'
import forgotimg from '../forgot-password.png'
import {auth, provider} from '../config/firebase'
import { sendPasswordResetEmail } from 'firebase/auth'
import { toast } from 'react-toastify'
const Resetpass = () => {
    const [email, setemail] = useState("")
    const navigate = useNavigate();
    const handleReset =(e) =>{
        e.preventDefault();
        sendPasswordResetEmail(auth, email)
       .then(() => {
        toast.success("Password Reset Link sent!!")
        setemail("")
        navigate("/login")
  })
  .catch((error) => {
    toast.error(error.message)
  });
    }
  return (
    <div>
       
        <div className='Home-cont'>
        <div className='left-home'>
          <img src={forgotimg}  />
        </div>
        <div className='right-home '>
        <form className='reset-form card' onSubmit={handleReset}>
            <h2 style={{color:"green"}}>RESET PASSWORD</h2>
            <input type='email' value={email} placeholder='Enter Your name' onChange={(e) =>{ setemail(e.target.value)}} className='reset-input' required/> 
            <button type='submit' className='reset-btn'>Send Reset Passwork link</button>

            <div className='d-flex' style={{gap:"20px"}}>
           <Link to='/login' className="btn btn-outline-primary" type="submit" style={{fontSize:"1.3rem"}}>Login</Link>
            <Link to='/signup' className="btn btn-outline-success" type="submit" style={{fontSize:"1.3rem"}}>Sign In</Link>
           </div>
          
        </form>
        </div>
        </div>
    </div>
  )
}

export default Resetpass